var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { onError } from "@ane/core/lib/decorators/OnError";
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let BudgetResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/budget/");
  }
  calculateTrafficUsage(postData) {
    return __async(this, null, function* () {
      const address = "CalculateTrafficUsage";
      const response = yield this._post(postData, address);
      return response;
    });
  }
};
__decorateClass([
  onError({
    message: `An error occurred while calculating the traffic usages for the isolation group. ${continuationErrorMessage}`
  })
], BudgetResources.prototype, "calculateTrafficUsage", 1);
BudgetResources = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], BudgetResources);
const BudgetResources$1 = new BudgetResources();
export {
  BudgetResources,
  BudgetResources$1 as default
};
//# sourceMappingURL=BudgetResources.js.map
